import type { Ref } from 'react';

import { isRefCallback } from './isRefCallback';
import { isRefObject } from './isRefObject';

/** Puts a value into a ref of either kind. */
export function setRef<T>(refTarget: Ref<T> | undefined, value: T | null): void {
    if (isRefObject<T>(refTarget)) {
        // `current` is typed read-only, but object refs are meant to be written.
        (refTarget.current as T | null) = value;
    } else if (isRefCallback(refTarget)) {
        refTarget(value);
    }
}
